export enum LoginStateEnum {
    login, 
    register, 
    forget,
    isFirst
  }